<template>
    <div>
        <div class="fx card points-background" @click="openPointsUseRulesSetting">
            <div class="left">
                <div class="title">
                    <i></i>
                    <span>积分抵现</span>
                </div>
                <div class="info">
                    <template v-if="pointDeductionActivity.amount != null">
                        <p>{{pointDeductionActivity.amount}}积分=1元</p>
                        <!-- <p>已引导充值：3000元</p> -->
                    </template>
                    <template v-else>
                        <p>暂未设置</p>
                    </template>
                </div>
            </div>
            <div class="right">
                <el-switch @click.native.stop :value="true" @change="pointDeductionSwitchChange(pointDeductionActivitySwitch)" v-model="pointDeductionActivitySwitch"></el-switch>
            </div>
        </div>
        <points-use-rules-setting :activity="pointDeductionActivity" @update="getPointDeductionActivity" ref="pointsUseRulesSetting"></points-use-rules-setting>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { createComponent, onBeforeMount, reactive, ref } from '@vue/composition-api'
import PointsUseRulesSetting from './points_use_rules_setting.vue'
import $fetch from '@/api'
import { openMessage } from '../../../../utils/system'
export default createComponent({
    setup(props, ctx) {
        const pointDeductionActivity = ref<{ // https://yapi.senguo.me/project/14/interface/api/5429
            status: number,
            amount: number,
            limitation: number, // 抵扣上限类型 {"0": "无上限", "1": "按积分确定上限", "2": "按比例确定上限"}
            point_ceiling: number,
            percentage_ceiling: number
        }>({})
        const pointDeductionActivitySwitch = ref(false)

        function openPointsUseRulesSetting() {
            (ctx.refs.pointsUseRulesSetting as any).open()
        }

        onBeforeMount(() => {
            getPointDeductionActivity()
        })

        function getPointDeductionActivity() {
            return $fetch.post({
                url: '/activity/getpointdeductionactivity',
                params: {}
            }).then(data => {
                pointDeductionActivity.value = data.activity
                pointDeductionActivitySwitch.value = data.activity.status === 0 ? true : false
            }).catch(e => {
                openMessage("error", e.message || "获取积分抵现活动失败")
            })
        }

        async function pointDeductionSwitchChange(newVal) {
            await changetPointDeductionActivityStatus(newVal ? 'enable' : 'disable')
            await getPointDeductionActivity()
        }

        async function changetPointDeductionActivityStatus(type: 'enable' | 'disable') {
            try {
                switch (type) {
                    case 'enable':
                        await $fetch.post({
                            url: '/activity/enablepointdeduction'
                        })
                        openMessage('success', '启用成功')
                        break
                    case 'disable':
                        await $fetch.post({
                            url: '/activity/disablepointdeduction'
                        })
                        openMessage('success', '停用成功')
                        break
                    default:
                        break
                }
            } catch (e) {
                openMessage('error', e.message || '修改状态失败')
            }
        }

        return {
            pointDeductionActivity,
            openPointsUseRulesSetting,
            getPointDeductionActivity,
            pointDeductionSwitchChange,
            pointDeductionActivitySwitch
        }
    },

    components: {
        PointsUseRulesSetting
    }
})
</script>

<style lang="scss" scoped>
.card {
    display: flex;
    padding: 19px 12px;
    margin-top: 12px;
    height: 100px;
    width: 252px;
    background: #F7F7F7;
    border-radius: 10px;
    user-select: none;
    cursor: pointer;

    &:active {
        background-color: #f0f0f0;
    }

    & + .card {
        margin-left: 19px;
    }

    .left {
        .title {
            display: flex;
            i {
                display: block;
                height: 16px;
                width: 4px;
                border-radius: 2px;
                background: #333;
                margin-right: 8px;
            }

            span {
                color: #333;
                font-size: 14;
                font-weight: bold;
            }
        }

        .info {
            margin-top: 10px;
            color: #999;
            font-size: 12px;
            line-height: 16px;
        }
    }

    .right {
        display: flex;
        flex: 1;
        margin-right: 9px;
        align-items: center;
        justify-content: flex-end;
    }
}

.points-background {
    background-image: url("~@/assets/images/a2.png");
    background-size: auto 100px;
    background-position: bottom right;
    background-repeat: no-repeat;
}
</style>